document.addEventListener("DOMContentLoaded", () => {
  const showMoreButtons = document.querySelectorAll(".expandable-section__toggle");
  
  showMoreButtons.forEach(button => {
    // Find the closest expandable section container
    const expandableSection = button.closest(".expandable-section");
    
    if (!expandableSection) {
      console.warn("Expandable section container not found for button:", button);
      return;
    }
    
    // Find the content container within this specific expandable section
    const contentContainer = expandableSection.querySelector(".expandable-section__content");
    
    if (!contentContainer) {
      console.warn("Expandable section content not found for button:", button);
      return;
    }
    
    checkIfExpandable(contentContainer, button);
    
    button.addEventListener("click", () => {
      if (contentContainer.classList.contains("expanded")) {
        // Collapse text
        contentContainer.classList.remove("expanded");
        button.textContent = button.dataset.showMore || "Show more";
      } else {
        // Expand text
        contentContainer.classList.add("expanded");
        button.textContent = button.dataset.showLess || "Show less";
      }
    });
  });
});

function checkIfExpandable(content, button) {
  // Temporarily remove line-clamp to measure full height
  const originalDisplay = content.style.display;
  const originalWebkitLineClamp = content.style.webkitLineClamp;
  const originalWebkitBoxOrient = content.style.webkitBoxOrient;
  const originalOverflow = content.style.overflow;
  
  // Set to block to measure full height
  content.style.display = 'block';
  content.style.webkitLineClamp = 'unset';
  content.style.webkitBoxOrient = 'unset';
  content.style.overflow = 'visible';
  
  const fullHeight = content.scrollHeight;
  
  // Restore original styles
  content.style.display = originalDisplay;
  content.style.webkitLineClamp = originalWebkitLineClamp;
  content.style.webkitBoxOrient = originalWebkitBoxOrient;
  content.style.overflow = originalOverflow;
  
  // Calculate approximate line height (assuming 1.5em line-height)
  const computedStyle = window.getComputedStyle(content);
  const fontSize = parseFloat(computedStyle.fontSize);
  const lineHeight = parseFloat(computedStyle.lineHeight) || fontSize * 1.5;
  
  // Calculate how many lines the content would be
  const lines = Math.ceil(fullHeight / lineHeight);
  
  // Hide button if content is 2 lines or less
  if (lines <= 2) {
    button.style.display = 'none';
  }
}